import type React from 'react';

export enum TOAST_STATUS {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
}

export type ToastState = {
  classname?: string;
  description?: React.ReactNode;
  status: TOAST_STATUS;
  title: string;
};
